import { Button, Grid, TextField } from "@mui/material";
import React, { useState } from "react";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { useUserAuth } from "../../context/UserAuthContext";
import dayjs, { Dayjs } from "dayjs";
import { useUpdateTenant } from "../../hooks/tenants/useUpdateTenant";
import { useTranslation } from "react-i18next";

interface ProfileOverviewEditFormProps {
  reloadUserData: any;
  onClose: any;
}

const ProfileOverviewEditForm = ({
  reloadUserData,
  onClose,
}: ProfileOverviewEditFormProps) => {
  const { t } = useTranslation();
  const { user } = useUserAuth();
  const [updatedTenant, setUpdatedTenant] = useState<any>(user?.tenant);
  const { update: updateTenant } = useUpdateTenant();

  const handleFormSubmit = async (event: any) => {
    event.preventDefault();
    try {
      const updatedTenantInfo = {
        id: updatedTenant?.id,
        name: updatedTenant?.name,
        surname: updatedTenant?.surname,
        phoneNumber: updatedTenant?.phoneNumber,
        birthDate: updatedTenant?.birthDate,
        sharedIncome: updatedTenant?.sharedIncome,
        email: user?.tenant?.email,
      };
      await updateTenant(updatedTenantInfo);
      await reloadUserData();
      onClose();
    } catch (err) {
      throw new Error("Something went wrong");
    }
  };

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { id, value } = event.target;

    setUpdatedTenant((prevTenant: any) => ({
      ...prevTenant,
      [id]: value,
    }));
  };

  const handleDateChange = (date: Dayjs | null) => {
    setUpdatedTenant((prevTenant: any) => ({
      ...prevTenant,
      birthDate: date ? date.format("YYYY-MM-DD") : null,
    }));
  };
  return (
    <form onSubmit={handleFormSubmit}>
      <Grid container spacing={3} paddingTop={2}>
        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
          <TextField
            fullWidth
            id="name"
            label={t("profile.firstname")}
            variant="outlined"
            value={updatedTenant?.name}
            onChange={handleInputChange}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
          <TextField
            fullWidth
            id="surname"
            label={t("profile.surname")}
            variant="outlined"
            value={updatedTenant?.surname}
            onChange={handleInputChange}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
          <TextField
            fullWidth
            id="phoneNumber"
            label={t("profile.phone")}
            variant="outlined"
            value={updatedTenant?.phoneNumber}
            onChange={handleInputChange}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
          <TextField
            fullWidth
            id="sharedIncome"
            label={t("profile.shared_income")}
            variant="outlined"
            value={updatedTenant?.sharedIncome}
            onChange={handleInputChange}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              sx={{ width: "100%" }}
              label={t("profile.dateofbirth")}
              format={"DD-MM-YYYY"}
              value={dayjs(updatedTenant?.birthDate)}
              onChange={handleDateChange}
            />
          </LocalizationProvider>
        </Grid>
        <Grid display={"flex"} justifyContent={"flex-end"} gap={1} item xs={12}>
          <Button type="submit" variant="contained">
            Opslaan
          </Button>
        </Grid>
      </Grid>
    </form>
  );
};

export default ProfileOverviewEditForm;
